<template>
  <el-container>
    <el-container>
      <el-aside class="left_menu_container" style="z-index:1">
        <leftMenu type="setting" />
      </el-aside>
      <el-main class="work_container">
        <div style="background-color: white;margin-left: 20px;height: 100vh;">
          <el-row style="clear:both;height:40px"></el-row>
          <el-row>
            <el-col :span="23" class="t_l" :offset="1">
              <span class="pageTitle">个人设置 </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23" :offset="1">
              <div style="width: 700px;">
                <br><br>
                <el-form ref="form" :model="userInfo" label-width="80px" label-suffix="                         ">
                  <el-row class="account_info_item">
                    <el-form-item label="头像">
                      <el-col :span="10">
                        <el-avatar :size="50" :src="userInfo.headPath" class="defaultAvatar"></el-avatar>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-upload class="avatar-uploader" action="/webApi/v3/file/uploadHeadImg" :show-file-list="false"
                          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                          <el-link :underline="false">修改</el-link>
                        </el-upload>
                      </el-col>

                    </el-form-item>
                  </el-row>
                  <el-row class="account_info_item">
                    <el-form-item label="手机号">
                      <el-col :span="10">
                        <el-input type="text" v-model="userInfo.mobile" disabled></el-input>
                      </el-col>

                      <el-col :offset="1" :span="4" v-if="userInfo.mobile">
                        <el-link :underline="false" @click="toModifyMobile">修改</el-link>
                        <el-link :underline="false" @click="toUnbindMobile">解绑</el-link>
                      </el-col>
                      <el-col :offset="1" :span="4" v-else>
                        <el-link :underline="false" @click="toModifyMobile">绑定</el-link>
                      </el-col>
                    </el-form-item>
                  </el-row>

                  <el-row class="account_info_item">
                    <el-form-item label="昵称">
                      <el-col :span="10">
                        <el-input type="text" v-model="userInfo.nickname" disabled></el-input>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-link :underline="false" @click="toModifyNickname">修改</el-link>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-row class="account_info_item">
                    <el-form-item label="密码">
                      <el-col :span="10">
                        <el-input type="text" v-model="userInfo.loginPwd" disabled></el-input>
                      </el-col>

                      <el-col :span="4" :offset="1">
                        <el-link :underline="false" v-if="userInfo.loginPwd" @click="toModifyPassword">修改</el-link>
                        <el-link :underline="false" v-else @click="toModifyPassword">设置</el-link>
                      </el-col>
                    </el-form-item>
                  </el-row>

                  <el-row class="account_info_item" v-if="userInfo.huawei">
                    <el-form-item label="华为账号">
                      <el-col :span="10">
                        <el-avatar :size="30" class="accountAvatar" :src="userInfo.huawei.headPic"></el-avatar>
                        {{ userInfo.huawei.nickName }}&nbsp;
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-link :underline="false" @click="toUnbindHuawei">解绑</el-link>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-row class="account_info_item">
                    <el-form-item label="微信账号">
                      <el-col :span="10">
                        <el-input type="text" v-model="weixinNickName" disabled></el-input>
                      </el-col>

                      <el-col :span="4" :offset="1">
                        <el-link :underline="false" v-if="userInfo.weixin" @click="toUnbindWechat">解绑</el-link>
                        <el-link :underline="false" v-else @click="bindWechat">绑定</el-link>
                      </el-col>
                    </el-form-item>
                  </el-row>

                  <el-row class="account_info_item" v-if="userInfo.mail">
                    <el-form-item label="邮箱">
                      <el-col :span="10">
                        <el-input type="text" v-model="userInfo.mail" disabled></el-input>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-row class="account_info_item" v-if="vipInfo">
                    <el-form-item label="账号类型">
                      <el-col :span="18">
                        <div :class="'vip_' + vipInfo.vipLevel">&nbsp;&nbsp;&nbsp;&nbsp; <el-link :underline="false"
                            href="/price.html">查看更多权益</el-link></div>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-row class="account_info_item" v-if="userInfo.mail">
                    <el-form-item label="会员时长">
                      <el-col :span="8">
                        截止 {{ vipInfo.vipEndDate }}
                      </el-col>
                    </el-form-item>
                  </el-row>

                </el-form>
              </div>

            </el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>

    <!---弹窗相关----->

    <price v-if="priceListDialogVisible" :show=priceListDialogVisible />

    <el-dialog title="修改手机号" :show-close=true :close-on-click-modal=false custom-class="xy_dialog" width="500px"
      :visible.sync="modifyDialogVisible">
      <div style="width:100%;height:0px;"></div>
      <el-form :model="modifyMobileForm" :rules="modifyMobileRules" ref="modifyMobileRuleForm" label-width="0px"
        class="modifyMobileForm">
        <h2 style="text-align:left">绑定手机号</h2>
        <h5 style="text-align:left;color:#999999">根据国家法律要求，只有绑定手机号才能享有写作权利</h5>
        <div style="width:100%;height:30px;"></div>
        <el-form-item prop="mobile">
          <el-input v-model="modifyMobileForm.mobile" placeholder="请输入新手机号" clearable></el-input>
        </el-form-item>

        <el-form-item prop="imgCaptcha">
          <el-input placeholder="图片验证码" v-model="modifyMobileForm.imgCaptcha">
            <template slot="append"><img :src="imgCaptchaSrc" class="imgCaptcha" @click="changeImgCaptchaSrc"
                alt="点击刷新" /></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="mobileCaptcha">
          <el-input placeholder="手机验证码" v-model="modifyMobileForm.mobileCaptcha">
            <template slot="append">
              <el-link type="primary" :underline="false" :disabled="mobileMsgSending"
                @click="sendMobileMsgModifyMobile">{{ mobileMsgBtnText }}</el-link>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
            @click="modifyMobile">&nbsp;&nbsp;&nbsp;&nbsp;修改手机号&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改密码" :close-on-click-modal=false width="500px" custom-class="xy_dialog"
      :visible.sync="modifyPasswordDialogVisible">

      <el-form :model="modifyPasswordForm" :rules="modifyPasswordRules" ref="modifyPwdRuleForm" label-width="0px"
        class="modifyMobileForm">
        <h2 style="text-align:left">修改密码</h2>
        <div style="width:100%;height:30px;"></div>
        <el-form-item prop="oldPwd" v-if="userInfo.loginPwd">
          <el-input v-model="modifyPasswordForm.oldPwd" placeholder="请输入原密码" show-password></el-input>
        </el-form-item>
        <el-form-item prop="newPwd">
          <el-input v-model="modifyPasswordForm.newPwd" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>

        <el-form-item prop="repeatPwd">
          <el-input v-model="modifyPasswordForm.repeatPwd" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="modifyPwd">&nbsp;&nbsp;&nbsp;&nbsp;修改密码&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改密码" :close-on-click-modal=false width="500px" custom-class="xy_dialog"
      :visible.sync="modifyNickNameDialogVisible">

      <el-form :model="modifyNickNameForm" :rules="modifyNickNameRules" ref="modifyNickNameFormRule" label-width="0px"
        class="modifyMobileForm">
        <h2 style="text-align:left">修改昵称</h2>
        <div style="width:100%;height:30px;"></div>
        <el-form-item prop="nickname">
          <el-input v-model="modifyNickNameForm.nickname" placeholder="请输入新的昵称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="modifyNickName">&nbsp;&nbsp;&nbsp;&nbsp;修改昵称&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-container>
</template>

<script>
import Qrcode from 'vue-qr'
import * as appJs from '../assets/js/app'
import price from './price'
import leftMenu from '../components/left_menu.vue'
export default {
  name: 'index',
  data: function () {
    var chackOldPwd = (rule, value, callback) => {
      if (!this.userInfo.loginPwd) {
        return callback()
      }
      if (!value) {
        return callback(new Error('原密码不能为空'))
      }
      if (value.length < 6) {
        return callback(new Error('密码格式不正确'))
      }
      return callback()
    }
    var checkRepeatPwd = (rule, value, callback) => {
      if (this.modifyPasswordForm.newPwd !== this.modifyPasswordForm.repeatPwd) {
        return callback(new Error('两次密码输入的不一致'))
      }
      if (this.modifyPasswordForm.oldPwd === this.modifyPasswordForm.repeatPwd) {
        return callback(new Error('新密码不能和原密码一样'))
      }
      return callback()
    }
    return {
      keyword: '',
      userInfo: {},
      menuIndex: '0',
      vipInfo: {
        weixin: {}
      },
      weixinNickName: '',
      vipMenu: 'vip',

      total: 1,
      priceListDialogVisible: 0,
      // 修改个人信息相关
      modifyDialogVisible: false,
      modifyMobileForm: {
        mobile: '',
        imgCaptcha: '',
        mobileCaptcha: ''
      },
      modifyMobileRules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        imgCaptcha: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' },
          { pattern: /\d{4}$/, message: '图片验证码格式错误', trigger: 'blur' }
        ],
        mobileCaptcha: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' },
          { pattern: /\d{6}$/, message: '短信验证码格式错误', trigger: 'blur' }
        ]
      },
      imgCaptchaSrc: '',
      mobileMsgSending: false,
      mobileMsgBtnText: '发送验证码',

      // 修改密码相关

      modifyPasswordDialogVisible: false,
      modifyPasswordForm: {
        oldPwd: '',
        newPwd: '',
        repeatPwd: ''
      },
      modifyPasswordRules: {
        oldPwd: [
          { validator: chackOldPwd, trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码长度不小于6位', trigger: 'blur' }
        ],
        repeatPwd: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码长度不小于6位', trigger: 'blur' },
          { validator: checkRepeatPwd, trigger: 'blur' }
        ]

      },
      modifyNickNameDialogVisible: false,
      modifyNickNameForm: {
        nickname: ''
      },
      modifyNickNameRules: {
        nickname: [
          { required: true, message: '昵称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
    genderFilter: function (val) {
      if (val === 'MALE') {
        return '男'
      } else if (val === 'FEMALE') {
        return '女'
      } else {
        return '未知'
      }
    },
    numFilter (value) {
      let realVal = parseFloat(value).toFixed(2)
      return realVal
    }
  },
  methods: {

    // 打开购买窗口
    openBuyDialog () {
      this.priceListDialogVisible++
    },

    getUserInfo () {
      let _this = this
      this.axios.get('/webApi/v3/user/userInfo').then(resp => {
        _this.userInfo = resp.data
        _this.weixinNickName = _this.userInfo.weixin && _this.userInfo.weixin.nickName;
      })
    },
    getVipInfo () {
      let _this = this
      appJs.getVip().then(data => {
        _this.vipInfo = data
      })
    },

    handleSelect (val) {
      this.menuIndex = val
      console.log('菜单：', val)
    },

    // 上传头像
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    // 头像上传成功
    handleAvatarSuccess (res, file) {
      this.getUserInfo()
    },
    // 修改手机号
    toModifyMobile () {
      this.changeImgCaptchaSrc()
      this.modifyDialogVisible = true
    },
    changeImgCaptchaSrc () { // 更换验证吗
      this.imgCaptchaSrc = '/webApi/v3/captcha/imgCaptcha?' + Math.random()
    },
    sendMobileMsgModifyMobile () { // 修改手机号发送验证码
      if (this.modifyMobileForm.mobile === this.userInfo.mobile) {
        this.$message.error('新手机号不能和原手机号一致')
        return
      }
      this.sendMobileMsg(this.modifyMobileForm)
    },

    sendMobileMsgModifyPwd () { // 修改免密发送验证码

    },
    sendMobileMsg (form) { // 发送短信验证码
      let _this = this
      let remaindTime = 60
      this.mobileMsgSending = true
      let timer = setInterval(() => {
        _this.mobileMsgBtnText = remaindTime + ' S'
        remaindTime--
        if (remaindTime <= 0) {
          clearInterval(timer)
          _this.mobileMsgSending = false
          _this.mobileMsgBtnText = '发送验证码'
        }
      }, 1000)

      this.axios.post('/webApi/v3/captcha/mobileCaptcha', form).then((response) => {
        _this.$message({
          message: '短信验证码发送成功',
          type: 'success'
        })
      }).catch(e => {
        _this.$message.error('短信验证码发送失败')
        clearInterval(timer)
        _this.mobileMsgSending = false
        _this.mobileMsgBtnText = '发送验证码'
      })
    },
    // 修改手机号
    modifyMobile () {
      let _this = this
      this.$refs.modifyMobileRuleForm.validate((valid) => {
        if (_this.modifyMobileForm.mobile === _this.userInfo.mobile) {
          _this.$message.error('新手机号不能和原手机号一致')
          return
        }
        if (valid) {
          this.axios.post('/webApi/v3/user/modifyMobile', _this.modifyMobileForm).then((response) => {
            _this.$message({
              message: '手机号修改成功',
              type: 'success'
            })
            _this.userInfo.mobile = _this.modifyMobileForm.mobile
            _this.modifyDialogVisible = false
          })
        }
      })
    },
    // 解绑手机号
    toUnbindMobile () {
      if (!this.userInfo.mail && !this.userInfo.huawei && !this.userInfo.weixin) {
        this.$confirm('你现在只能通过手机号登录，如果解绑手机号，本账号将注销，所有权益无法找回,确认注销?', '注销警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.unbindMobile()
        })
      } else {
        this.$confirm('您将解绑手机号，解绑后将无法通过手机号登录，确认解绑?', '解绑警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbindMobile()
        })
      }
    },
    unbindMobile () { // 调用解绑接口
      let _this = this
      this.axios.get('/webApi/v3/user/unBindMobile').then((response) => {
        _this.$message({
          message: '手机号解绑成功',
          type: 'success'
        })
        _this.getUserInfo()
      })
    },
    toModifyNickname () { // 修改昵称
      this.modifyNickNameDialogVisible = true
    },
    modifyNickName () {
      let _this = this
      this.$refs.modifyNickNameFormRule.validate((valid) => {
        if (valid) {
          _this.axios.post('/webApi/v3/user/modifyUserInfo', _this.modifyNickNameForm).then((response) => {
            _this.$message({
              message: '昵称修改成功',
              type: 'success'
            })
            _this.userInfo.nickname = _this.modifyNickNameForm.nickname
            _this.modifyNickNameDialogVisible = false
          })
        }
      })
    },
    // 修改 、设置密码
    toModifyPassword () {
      this.modifyPasswordDialogVisible = true
    },
    // 修改密码
    modifyPwd () {
      let _this = this
      this.$refs.modifyPwdRuleForm.validate((valid) => {
        if (valid) {
          this.axios.post('/webApi/v3/user/modifyPasswd', _this.modifyPasswordForm).then((response) => {
            _this.$message({
              message: '密码修改成功',
              type: 'success'
            })
            _this.modifyPasswordDialogVisible = false
            _this.userInfo.loginPwd = '******'
          })
        }
      })
    },
    // 解绑绑定微信
    toUnbindWechat () {
      if (!this.userInfo.mail && !this.userInfo.huawei && !this.userInfo.mobile) {
        this.$confirm('你现在只能通过微信号登录，如果解绑微信，本账号将注销，所有权益无法找回,确认注销?', '注销警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.unbindWechat()
        })
      } else {
        this.$confirm('您将解绑微信，解绑后将无法通过微信登录，确认解绑?', '解绑警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbindWechat()
        })
      }
    },
    unbindWechat () {
      let _this = this
      this.axios.get('/webApi/v3/user/unbindWechat').then((response) => {
        _this.$message({
          message: '微信解绑成功',
          type: 'success'
        })
        _this.getUserInfo()
      })
    },
    // 绑定微信
    bindWechat () {
      let tempUrl = window.location.href
      this.axios.get('/webApi/v3/wechat/authUrl?from=' + encodeURIComponent(tempUrl)).then((response) => {
        window.location.href = response.data
      })
    },
    // 解绑华为
    toUnbindHuawei () {
      if (!this.userInfo.mail && !this.userInfo.weixin && !this.userInfo.mobile) {
        this.$confirm('你现在只能通华为登录，如果解绑华为，本账号将注销，所有权益无法找回,确认注销?', '注销警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.unbindHuawei()
        })
      } else {
        this.$confirm('您将解绑华为，解绑后将无法通过华为登录，确认解绑?', '解绑警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbindHuawei()
        })
      }
    },
    unbindHuawei () {
      let _this = this
      this.axios.get('/webApi/v3/user/unbindHuawei').then((response) => {
        _this.$message({
          message: '华为解绑成功',
          type: 'success'
        })
        _this.getUserInfo()
      })
    }
  },
  computed: {

  },
  components: {
    leftMenu,
    qrcode: Qrcode,
    price
  },
  mounted () {
    this.getUserInfo()
    this.getVipInfo()
  },
  watch: {
    userInfo: function () {
      this.$store.commit('refreshUserInfo')
    }
  }
}
</script>
<style lang="less">
@import '../assets/css/index.less';

.priceDialog {
  .el-dialog__header {
    padding: 0px !important;
  }
}
</style>
<style lang="less" scoped>
@import '../assets/css/index.less';

.vip_GOLD::before {
  content: "黄金VIP";
  padding: 7px 5px;
  color: #3C4258;
  font-size: 12px;
  border-radius: 4px;
  background-image: linear-gradient(to bottom, #F0E1B8, #D4B380);
}

.vip_SILVER::before {
  background-image: linear-gradient(to bottom, #F7F7F7, #D5D8DE);
  content: "白银版";
  padding: 7px 5px;
  color: #3C4258;
  font-size: 12px;
  border-radius: 4px;

}

.price_rate {
  position: absolute;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #ff7f7f;
  color: white;
  padding-top: 35px;
  width: 70px;
  font-size: 0.5em;
  top: -22px;
  right: -33px;
  height: 18px;
}

.price_title {
  margin-top: 20px;
  margin-bottom: 15px;
  font-size: 1.2em;
}

.price_total {
  margin-top: 15px;
  margin-bottom: 15px;
}

.price_avg {
  margin-top: 15px;
  margin-bottom: 30px;
}

.price_origin {
  text-decoration: line-through;
  margin-top: 15px;
  margin-bottom: 30px;
}

.imgCaptcha {
  width: 100px;
}

.qrcodeContainer {
  text-align: center !important;
}

.accountAvatar {
  top: 10px;
  position: relative;
}

.avatar-uploader {
  // text-align: center !important;
}
</style>
<style lang="less" >
.modifyMobileForm {
  .el-input-group__append {
    z-index: 99;
    background-color: white;
    padding: 0px 5px;
    border-left: 0px !important;
  }
}

.work_container {
  padding: 0px;
  min-width: 930px;

  p {
    text-align: left;
  }

  h6 {
    color: black;
    text-align: left;
  }

  .vipTitle {
    color: black;
    font-size: 1.2em;
    margin: 10px 5px;
  }

  .vipTip {
    font-size: 0.9em;
  }

  .vipTag {
    background-color: #eaf3ff;
    border-radius: 0;
    color: #333333;
    font-size: 1.2em;
    padding: 0px 30px;
    line-height: 60px;
    height: 60px;
    float: left;
    margin-right: 50px;
  }

  .vipBuyBtn {
    width: 135px;
    margin-top: 14px;
  }

  .title_lable {
    width: 100%;
    // text-align-last: justify;
    // text-align: justify;
    // text-justify: distribute-all-lines;
    // width: 86px;
    display: inline-block;
    text-align: left;
  }

  .account_info_item {
    height: 70px;
    width: 700px;
    line-height: 50px;
    text-align: left;

    .el-form-item__content {
      padding-left: 20px;
    }
  }
}

.price_package_container {
  padding: 0px 10px !important;
  height: auto !important;
  overflow: hidden;
  width: 125px !important;
  margin-right: 25px;
}

.price_package_container .el-radio__input {
  display: none;
}

.payTypeBtn {
  width: 150px;
  height: 50px !important;

  .el-radio__input {
    top: -9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/userInfo.vue